import NavBar from "../../components/navbar";
import Theme from "../../assets/theme/theme";
import About from "./about";
import Contact from "./contact";
import Services from "./services"


import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { CssBaseline } from "@mui/material";

import {useState, createContext} from 'react';
import {useLocation} from 'react-router-dom';

export const LanguageContext = createContext();

export default function Index(props) {
  const location = useLocation();

  const language = location.state === null ? 'hu' : location.state
  const [lang, setLang] = useState(language==='en' ? 'en' : 'hu')
  const toggleLang = () => {
    setLang((prevLang) => (prevLang === 'hu' ? 'en' : 'hu'));
  }


 
  return (
    <div>
      <LanguageContext.Provider value={{lang, toggleLang}}>
      <Theme>
      <CssBaseline />
      <NavBar />

      <Box
        sx={{
          display: "flex",
          overflowX: "hidden",
        }}
      >
        <Box
          component="main"
          sx={{
            width: "100%",
            maxWidth: "md",
            padding: "1rem",
            mx: "auto",
          }}
        >
          <Toolbar />

          <Services />
          <About />
          <Contact />
        </Box>
      </Box>
      </Theme>
      </LanguageContext.Provider>
    </div>
  );
}
